import { ContainerModule } from '@evertel/di'
import { HistoryTableController } from './controller/'
import { AuditsSearchController } from './controller/'
import { UsageByUserController } from './controller/'
import { DepartmentUsersListController } from './controller/'

const DI_WEB_ADMIN_MODULE = new ContainerModule((m) => {
    m.bind(HistoryTableController).toSelf()
    m.bind(AuditsSearchController).toSelf()
    m.bind(UsageByUserController).toSelf()
    m.bind(DepartmentUsersListController).toSelf()
})


export { DI_WEB_ADMIN_MODULE }
